import { __rest } from "tslib";
import { getIn } from 'formik';
export const mapFieldToInputProps = (_a) => {
    var { field, form: { touched, errors, setFieldTouched, setFieldValue, initialErrors, values }, required, warningValidator } = _a, props = __rest(_a, ["field", "form", "required", "warningValidator"]);
    const fieldError = getIn(errors, field.name);
    const fieldTouched = getIn(touched, field.name);
    const initialFieldError = getIn(initialErrors, field.name);
    const warningMessage = warningValidator === null || warningValidator === void 0 ? void 0 : warningValidator(getIn(values, field.name));
    const error = (fieldTouched ? fieldError : initialFieldError) || '';
    let isValid;
    if (error) {
        isValid = false;
    }
    else if (fieldTouched && field.value) {
        isValid = true;
    }
    const isError = isValid === false;
    return Object.assign(Object.assign(Object.assign({}, field), props), { isValid,
        warningMessage, warning: Boolean(!isError && warningMessage), errorMessage: error, isError, onBlur: (event) => {
            setFieldTouched(field.name, true);
            if (props.onBlur) {
                props.onBlur(event);
            }
        }, onChange: (value, event) => {
            setFieldValue(field.name, value);
            if (props.onChange) {
                props.onChange(value, event);
            }
        } });
};
//# sourceMappingURL=map-field-to-input-props.js.map